import { createApp } from 'vue'
import SloneApp from './App.vue'

createApp(SloneApp).mount('#player')
